// extracted by mini-css-extract-plugin
export default {"background":"Background_background__QnZb0","startGrid":"Background_startGrid__DCLb3","grid":"Background_grid__-+nVH"};